import { useContext } from "react";
import { ToastContext } from "../ToastContext";
export function useToast() {
  var _useContext = useContext(ToastContext),
      showToast = _useContext.showToast,
      hideToast = _useContext.hideToast;

  return {
    showToast: showToast,
    hideToast: hideToast
  };
}